<template>
  <div class="d-flex fw-wrap jc-start m-t-6:d p-x-4:d">
    <div class="CREDENTIAL-CONTAINER">
      <div :class="{'bg-green': credentials.isLicensed}" class="CREDENTIAL-BADGE">
        <vk-icon name="medal" size="25"/>
      </div>
      <div>
        <div>Licensed</div>
        <div v-if="credentials.isLicensed">
          {{ credentials.licenseNumber }}
          <template v-if="credentials.licenseState">
            ({{ credentials.licenseState }})
          </template>
        </div>
        <div v-else>NA</div>
      </div>
    </div>

    <div class="CREDENTIAL-CONTAINER">
      <div :class="{'bg-green': credentials.isInsured}" class="CREDENTIAL-BADGE">
        <vk-icon name="shield-padded" size="35"/>
      </div>
      <div>
        <div>Insured</div>
        <div v-if="credentials.isInsured">
          ${{ credentials.insuredAmount | formatNumber }}
        </div>
        <div v-else>NA</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'pro-credentials',
  props: {
    publicProfileId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    credentials () {
      return this.$store.getters['jobrequest/matches/publicProfileCredentials'](this.publicProfileId);
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .CREDENTIAL-CONTAINER {
    @include padding-y(1);
    @include padding-x(5);
    @include text-medium();
    display: flex;
    color: $color-gray50;
    border: 1px solid $color-gray40;
  }

  .CREDENTIAL-CONTAINER:first-of-type,
  .CREDENTIAL-CONTAINER:last-of-type {
    border-left: none;
    border-right: none;
  }

  .CREDENTIAL-BADGE {
    @include square(40px);
    @include margin-right(1);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: $color-gray20;
    color: white;
  }

  .CREDENTIAL-BADGE:last-child {
    @include margin-right(0);
  }
</style>
